import { useIntl } from '@/intl'
import { Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from './Item'

export interface SustainabilityCertificateInfoProps {
  title: string
}

export function SustainabilityCertificateInfo({ title }: SustainabilityCertificateInfoProps) {
  const intl = useIntl()
  const content = intl.formatMessage({ id: 'accommodation_page_sustainability_certificate_content' })

  return (
    <Item elementDL="sustainably certified" title={title} Glyph="Leaf">
      {/* eslint-disable-next-line react-dom/no-dangerously-set-innerhtml -- Content comes from translations */}
      <Typography dangerouslySetInnerHTML={{ __html: content }} />
    </Item>
  )
}
